import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const ReferralGiftRouteEntryPageContent = lazy(
  () => import('./ReferralGiftRouteEntryPageContent'),
);

export const ReferralGiftRouteEntryPage = wrapNavigatorScreen(
  ReferralGiftRouteEntryPageContent,
  {
    cardOverlayEnabled: true,
    animationEnabled: false,
    detachPreviousScreen: false,
    cardStyle: {
      backgroundColor: 'transparent',
    },
    headerShown: false,
  },
);
